import { http } from "../http/Http";
import { Configurations } from "../models/Configurations";

export class ConfigurationsService {

    getAll = async (): Promise<Configurations> => {
        const { data } = await http.get<Configurations>("Configurations/GetAll");
        return data;
    };
}